import {useNavigate} from "react-router-dom";
import React, {useContext, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import {CardContent, TextareaAutosize} from "@mui/material";
import {Col, Modal, Row} from "react-bootstrap";
import MDButton from "../../components/MDButton";
import {parseCustomersFromInput} from "../common/CustomerImportUtil";
import MDTypography from "../../components/MDTypography";
import {customerBatchImport} from "../common/api/CustomerProfileApi";

export default function ImportCustomers(props) {

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();
  const [customerInput, setCustomerInput] = useState('');
  const [customerResult, setCustomerResult] = useState([]);

  const handleViewCustomer = (row) => {
    navigate('/client/' + row.guid);
  }

  const doToast = () => {
    let _context = {...context};
    const toastMessage = 'Import successful.';
    _context.toast = {
      message: toastMessage,
      type: 'success'
    }
    setContext({..._context});
  }

  const formattedAddress = (row) => {
    let a = [];
    if (row.address) {
      a.push(row.address);
    }
    let _cityState = []
    if (row.city) {
      _cityState.push(row.city);
    }
    if (row.state) {
      _cityState.push(row.state);
    }
    if (_cityState.length > 0) {
      a.push(_cityState.join(', '))
    }
    if (row.postalCode) {
      a.push(row.postalCode);
    }
    return a.join(' ');
  }

  const [processing, setProcessing] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importSuccess, setImportSuccess] = useState(false);
  const [processed, setProcessed] = useState(false);
  const processCustomerInput = () => {
    setProcessing(true);
    setProcessed(false);
    const results = parseCustomersFromInput(customerInput);
    setCustomerResult(results);
    setProcessing(false);
    setProcessed(true);
  }

  const processCustomerImport = () => {
    setImporting(true);
    let request = {
      customers: customerResult
    }
    customerBatchImport(request).then(result => {
      setImporting(false);
      setImportSuccess(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setImportSuccess(true);
        setProcessed(false);
        doToast();
      }
    });
  }

  return (

    <DashboardLayout>

      <Meta pageTitle={'Import Customers'}/>

      <ContextSearchNavbar title="Import Customers"/>

      <MDBox py={3}>
        <MDBox mb={3}>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <MDTypography variant="p" color="secondary" fontWeight="light">
                    Import Customers from csv file. <br/>
                    Customer info should be in a new line, ie
                  </MDTypography>
                    <p>FirstName, LastName, Email, Address 1, City, StateName, StateAbbreviation, PostalCode, Phone
                      <br/>
                      John,Doe,john.doe@example.com,123 Main St,Springfield,Illinois,IL,62704,555-123-4567</p>
                  <Grid container spacing={2}>
                    <Grid item sm={12}>
                      <Row className={'my-4'}>

                        <Col className={'col'} sm={12} xs={12}>
                          <div className="form-group native-margin-fix">
                            <label htmlFor="name" className={"native-label"}>Import Customers</label>
                            <TextareaAutosize
                              autoComplete="off"
                              minRows={15}
                              onChange={(e) => {
                                setCustomerInput(e.target.value);
                              }}
                              className="form-control" id="desc"
                              placeholder={'Paste Customer Import'}/>
                          </div>
                        </Col>
                      </Row>
                      <Row className={'my-4'}>
                        <Col className={'col'} sm={12} xs={12}>
                          <MDButton
                            color="info"
                            size="small"
                            className="pull-right"
                            disabled={!customerInput || processing}
                            onClick={(e) => {
                              processCustomerInput()
                            }}>
                            {processing ? 'Converting...' : 'Preview'}
                          </MDButton>
                        </Col>
                      </Row>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      {processed && <>
        <Modal show={processed} size="lg" onHide={() => {
          setProcessed(false)
        }}>
          <Modal.Header closeButton>
            <Modal.Title>Import Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-striped">
              <thead>
              <tr>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Address</th>
              </tr>
              </thead>
              <tbody>

              {customerResult?.length > 0 && customerResult?.map((result, idx) => {
                return (
                  <tr key={idx} className={'my-4'}>
                    <td>
                      {result.firstName}
                    </td>
                    <td>
                      {result.lastName}
                    </td>
                    <td>
                      {result.email}
                    </td>
                    <td>
                      {result.phoneNumber}
                    </td>
                    <td>
                      {formattedAddress(result)}
                    </td>
                  </tr>
                )
              })
              }
              </tbody>
            </table>

          </Modal.Body>
          <Modal.Footer>
            <MDButton
              color="info"
              size="small"
              className="pull-right"
              disabled={importing}
              onClick={(e) => {
                processCustomerImport()
              }}>
              {importing ? 'Importing Customers...' : 'Import Customers'}
            </MDButton>
          </Modal.Footer>
        </Modal>
      </>}

      <Footer mt={5}/>

    </DashboardLayout>
  );
}